module.exports = __webpack_public_path__ + "img/slide6.b3327e7d.jpg";